import React, { useState } from "react";

import FilterInput from "../../../../components/filter-input/filter-input-layout";
import SelectBox from "../../../../components/select-box/select-box";
import { Button } from "../../../../components/buttons";
import { FilterContainer } from "./filter-style";

import { getRelatedMediatorsCodes } from "../../../../utils/mediatorCode";
import { MediatorCodesInputType } from "../../clients-dashboard/clients-dashboard-types";
import { FilterProps } from "../debt-recovery-types";
import { DOC_NUMBER_MAX_LENGTH } from "../../../../constants";

const Filter = ({ mediator, onGetData, filter, setFilter }: FilterProps) => {
  const [formatError, setFormatError] = useState<string>("");

  const mediatorCodesInput: MediatorCodesInputType = {
    codeOptions: getRelatedMediatorsCodes(mediator),
    selectedCode: filter.mediatorCode,
  };

  const getIsValidFilter = () => {
    const dniRegex = /^\d{8}[A-Z]$/;
    const nieRegex = /^[XYZ]\d{7}[A-Z]$/;
    const nifRegex = /^[A-Z]\d{7}[A-Z0-9]$/;
    const pasaporteRegex = /^[A-Z0-9]{5,15}$/;
    // const cifRegex = /^[ABCDEFGHJKLMNPQRSUVW]\d{7}[0-9A-J]$/;

    setFormatError("");
    if (dniRegex.test(filter.takerNif)) return true;
    if (nieRegex.test(filter.takerNif)) return true;
    if (nifRegex.test(filter.takerNif)) return true;
    if (pasaporteRegex.test(filter.takerNif)) return true;
    // if (cifRegex.test(filter.takerNif)) return true;
    setFormatError("Formato no reconocido");
    return false;
  };

  const handleOnChangeTaker = (value: string) => {
    setFormatError("");
    setFilter((prevFilter) => ({ ...prevFilter, takerNif: value }));
  };

  const handleOnSearch = () => {
    const isValidFilter = getIsValidFilter();
    if (isValidFilter) onGetData();
  };

  return (
    <FilterContainer>
      <div className="inputBox">
        <FilterInput
          placeholder={"NIF/NIE/PASAPORTE"}
          onChange={(value: string) => handleOnChangeTaker(value)}
          showError={!!formatError}
          errorText={formatError}
          required
          maxLength={DOC_NUMBER_MAX_LENGTH}
        />
      </div>
      <div className="selectBox relatedMediators">
        <SelectBox
          isMediator
          optionsText={mediatorCodesInput.codeOptions}
          optionKey="value"
          optionValue="label"
          defaultValue={filter.mediatorCode}
          initialValue={mediatorCodesInput.selectedCode}
          propValue={mediatorCodesInput.selectedCode}
          disabled={mediatorCodesInput.codeOptions.length < 2}
          required
          onChange={(value: string) => setFilter({ ...filter, mediatorCode: value })}
        />
        <label>Mediador</label>
      </div>
      <div className="button-container">
        <Button text="Buscar" disabled={!filter.takerNif.length} onClick={handleOnSearch} />
      </div>
    </FilterContainer>
  );
};

export default Filter;
